import TrackingView from '../TrackingView.vue'
import TrackingPage from '../Pages/TrackingPage.vue'
import ShiftRoutePage from '../Pages/ShiftRoutePage.vue'

const routes = [
  {
    path: '/tracking',
    component: TrackingView,
    name: 'tracking',
    children: [
      {
        path: '',
        name: 'tracking-fleet',
        component: TrackingPage
      },
      {
        path: 'shifts/:id/route',
        name: 'shift-route',
        component: ShiftRoutePage
      }
    ]
  }
]

export default routes
